(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["io-size-persistence"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('io-size-persistence')) {
    customElements.define('io-size-persistence', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.section = this.closest('.product-section');
        this.wrapper = this.closest('.ironoak-product-page-swatches-wrapper');
        if (!this.section || !this.wrapper) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.links = Array.from(this.wrapper.querySelectorAll('[data-io-size-link]'), link => ({
          link,
          original: link.dataset.productUrl,
          variants: JSON.parse(link.dataset.sizeVariants)
        }));
        this.section.addEventListener('change', () => this.updateLinks(), options);
        this.section.addEventListener('variantChange', () => this.updateLinks(), options);
        this.wrapper.addEventListener('click', event => this.followLink(event), options);
        this.wrapper.addEventListener('auxclick', event => this.followLink(event), options);
        document.addEventListener('zrx-satc-loaded', () => this.syncStickySize(), options);
        this.syncStickySize();
        document.addEventListener('DOMContentLoaded', () => this.updateLinks(), options);
        window.addEventListener('pageshow', () => this.updateLinks(), options);
        this.updateLinks();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      syncStickySize() {
        const stickyProduct = window.zoorix_sticky_atc_product;
        if (!window.ZoorixStickyAtc?.store || stickyProduct?.handle !== this.section.dataset.productHandle) return;
        const variantId = new URL(window.location.href).searchParams.get('variant');
        if (variantId && stickyProduct.variants.some(variant => String(variant.id) === variantId)) {
          window.dispatchEvent(new Event('locationchange'));
        }
      }

      selectedSize() {
        const index = this.dataset.optionIndex;
        const input = this.section.querySelector(
          '[data-variant-input][data-index="' + index + '"]:checked, select[data-variant-input][data-index="' + index + '"]'
        );
        return input?.value;
      }

      updateLinks() {
        const size = this.selectedSize();
        this.querySelector('[data-size-notice]').hidden = true;
        for (const entry of this.links) {
          const matches = entry.variants.filter(variant => variant.size === size);
          const variant = matches.find(match => match.available) || matches[0];
          const url = new URL(entry.original, window.location.href);
          if (variant) url.searchParams.set('variant', variant.id);
          entry.link.setAttribute('href', url.pathname + url.search + url.hash);
          entry.missingSize = size && !variant ? size : null;
        }
      }

      followLink(event) {
        if (event.type === 'auxclick' && event.button !== 1) return;
        const link = event.target.closest('[data-io-size-link]');
        if (!link) return;
        this.updateLinks();
        const entry = this.links.find(item => item.link === link);
        if (!entry?.missingSize) return;
        event.preventDefault();
        const template = this.querySelector('[data-size-notice-template]').content.textContent;
        this.querySelector('[data-size-notice-text]').textContent = template
          .replace('[size]', entry.missingSize)
          .replace('[product]', link.dataset.productTitle);
        this.querySelector('[data-size-notice-link]').href = entry.original;
        this.querySelector('[data-size-notice]').hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
